$(document).on("itinerary-form:ready", () => {
  $(".tribes-select").select2({ placeholder: "Select Connected Tribes..." });
  $(".users-select").select2({ placeholder: "Select Connected Editors..." });
  $(".listing-list-select").select2({ placeholder: "Select Listings..." });
  $(".region-list-select").select2({ placeholder: "Select Region" });
  $(".category-list-select").select2({ placeholder: "Select Theme Types..." });
});

$(document).on(
  "admin-listings-index:ready admin-tribes-index:ready admin-users-index:ready",
  () => {
    $("#search-listings, #search-users").keypress(function (e) {
      if (e.keyCode === 13) {
        $(this).closest("form").submit();
      }
    });

    $("#theme-filter, #type-filter, #region-filter, #tribe-filter").on(
      "change",
      function () {
        $(this).closest("form").submit();
      }
    );

    $(".clickable-header").click(function (e) {
      e.preventDefault();
      const sortType = $(this).data("sort-type");
      let form;

      if ($("#listing-sort-field").length) {
        form = $("#listing-sort-field").closest("form");
      } else if ($("#user-sort-field").length) {
        form = $("#user-sort-field").closest("form");
      } else if ($("#tribe-sort-field").length) {
        form = $("#tribe-sort-field").closest("form");
      } else {
        form = $(this).closest("table").parent().find("form").first();
        if (!form.length) {
          console.error("Sorting form not found via fallback!");
          return;
        }
      }

      const sortDirField = form.find('input[name="dir"]');
      const sortField = form.find('input[name="sort"]');

      if ($(this).hasClass("active-asc")) {
        sortDirField.val("DESC");
      } else {
        sortDirField.val("ASC");
      }

      sortField.val(sortType);
      form.submit();
    });

    $(".clickable-header").each(function () {
      const header = $(this);
      let form;
      if ($("#listing-sort-field").length) {
        form = $("#listing-sort-field").closest("form");
      } else if ($("#user-sort-field").length) {
        form = $("#user-sort-field").closest("form");
      } else if ($("#tribe-sort-field").length) {
        form = $("#tribe-sort-field").closest("form");
      } else {
        form = header.closest("table").parent().find("form").first();
        if (!form.length) return;
      }

      const sortField = form.find('input[name="sort"]');
      const sortDirField = form.find('input[name="dir"]');

      header.removeClass("active-asc active-desc");
      if (sortField.val() === header.data("sort-type")) {
        if (sortDirField.val() === "DESC") {
          header.addClass("active-desc");
        } else {
          header.addClass("active-asc");
        }
      }
    });
  }
);
